import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { DTODiffusionModelsTablePageSettingsUD } from '@shared/dto/+diffusion_model/+ud/table/dto_diffusion_models_table_page_settings_ud';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../_base/createAsyncThunkSafe';
import { diffusion_models_ud_update_current_table_with_settings } from './_methods/diffusion_models_ud_update_current_table_with_settings';
import { StateMLAsset } from './state_ml_asset';

export const remote_ml_asset_load_page_items = createAsyncThunkSafe<void, DTODiffusionModelsTablePageSettingsUD>(
  ENUM__network_event_client_to_server.ML_ASSET_LOAD_PAGE_ITEMS,
  async (request: DTODiffusionModelsTablePageSettingsUD) => {
    await send_to_server(ENUM__network_event_client_to_server.ML_ASSET_LOAD_PAGE_ITEMS, request);
  },
);

export function init_remote_ml_asset_load_page_items(builder: ActionReducerMapBuilder<StateMLAsset>) {
  builder
    .addCase(remote_ml_asset_load_page_items.pending, async (state, action) => {
      let settings_table = action.meta.arg;

      diffusion_models_ud_update_current_table_with_settings(state, settings_table);

      let hash_crc32_table_page = await settings_table.update_hash();

      state.page_settings_loading_in_progress.add(hash_crc32_table_page);

      //need for force re-render
      state.page_settings_loading_in_progress = new Set(state.page_settings_loading_in_progress);
    })
    .addCase(remote_ml_asset_load_page_items.rejected, (state, action) => {})
    .addCase(remote_ml_asset_load_page_items.fulfilled, (state, action: PayloadAction<void>) => {});
}
